<!--分享提示-->
<template>
  <div
    class="shareTip-top"
    :data-show="isHide"
    v-show="isShow"
    v-if="threeDimensionCar.show && hasRedPacket"
    >
    分享赢好礼
    <i class="shareTip-top-close" @click="close"></i>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import utils from '../utils/util';
export default {
  data () {
    return {
      isShow: true
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      hasRedPacket: 'intended/hasRedPacket'
    }),
    ...mapGetters('phoneCall', { 'phoneCallStatus': 'phoneCallStatus' }),
    ...mapGetters('frame', { 'threeDimensionCar': 'threeDimensionCar' }),
    hasRedPacket () {
      return (utils.browser.isApp || utils.browser.isPriceApp) && this.phoneCallStatus === 0 &&
        this.hasRedPacket;
    },
    isHide () {
      return this.hasRedPacket && this.threeDimensionCar.show && this.isShow;
    }
  },
  watch: {
    hasRedPacket(newVal, oldVal) {
      this.updateIsShow();
    },
    'threeDimensionCar.show': function (newVal, oldVal) {
      this.updateIsShow();
    },
  },
  methods: {
    close () {
      this.isShow = false;
    },
    updateIsShow() {
      if (this.hasRedPacket && this.threeDimensionCar.show) {
        setTimeout(() => {
          this.isShow = false;
        }, 10000);
      }
    },
  },
  
};
</script>
<style scoped>
.shareTip-top {
  position: fixed;
  top: 0.125rem;
  right: 0.5rem;
  padding: 0.3rem 1.35rem 0.3rem 0.6rem;
  background: #fe4a3b;
  border-radius: 0.2rem;
  font-size: 0.55rem;
  color: #fff;
  white-space: nowrap;
  text-overflow: ellipsis;
  z-index: 1100;
}

.shareTip-top:before {
  content: "";
  position: absolute;
  top: -0.125rem;
  right: 0.9rem;
  width: 0.35rem;
  height: 0.15rem;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAGCAYAAAAYLBS/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjM5QkFGQ0I0QzgwODExRUFCNTI4RTM2MjUzQzkzNTlEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjM5QkFGQ0I1QzgwODExRUFCNTI4RTM2MjUzQzkzNTlEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzlCQUZDQjJDODA4MTFFQUI1MjhFMzYyNTNDOTM1OUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzlCQUZDQjNDODA4MTFFQUI1MjhFMzYyNTNDOTM1OUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz40ySWzAAAAxUlEQVR42mL8//8/Azr48+SRJJBiYpGRe8qADYA0IePfN69p/Hcw+AHE/4FsbXR5sCXInF83rmr8czL+/M9Y6T8YOxn/B4phaGQC2fYT6JRf169qsWTFnmb49IGHQVKGAYw/fWAAil0ByukB1TBD1TKDNTGeP2PEmp90lfHTRx4GCSkGhn9/IRjIBooxAOUuAtWYgv3z8QMr499g11uMH95JMv78yfNfQBCo+B+qp5mYGBg/vGf4z87O8F9A6C0j0CaAAAMAsFN//bj6jH8AAAAASUVORK5CYII=")
  no-repeat center center;
  background-size: 0.35rem;
}

.shareTip-top-close {
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  right: 0.25rem;
  top: calc(50% - 0.375rem);
  margin: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAAlklEQVQoFaVS2w2AIAwE458TsobO4RzMYuJOeAeElEirxialpXd9QOocJKW00L6RxqUDPaDrUyI5lVsa1cAJu2nJxKDk9A0EcEu2sNxoRBjFSJ7laN77HUSGQrXZxxGJ8WKK6KK+ezIrGGA3KnnsBhOgkXdIHtscVYzYfnYUK/XqaRFUDAA3Qv0I1hbJZQEQ+LVyn5f8AtG/1EIIDVjAAAAAAElFTkSuQmCC)
  no-repeat;
  background-size: 0.3rem 0.3rem;
  background-position: center center;
}
</style>
